<template>
  <div
    id="app"
    :style="{'height':iosHeight}"
  >
    <div class="app-title">
      <div
        class="back-btn"
        @click="backPrePage"
      ><img
          class="back-img"
          :src="backIcon"
          alt=""
        ></div>
      <div class="back-btn-blank"></div>
      <div class="title">{{ pageTitle }}</div>
      <div
        class="option"
        @click.stop="showMoreBar"
      >
        <!-- <span v-if="!isNewsPage">

        </span> -->
        <!-- <img :src="selectIcon" />  -->
        <img
          class="option__bar"
          v-if="!isNewsPage"
          :src="morebarImg"
          alt=""
        >
        <morebar-pop
          @onMask="onBarMask"
          v-if="isShowMoreBar"
          @hidePop="isShowMoreBar=false"
          @onSelectTime="showDatePanel"
          @onRefresh="refresh"
          @onAbout="showEdition"
        ></morebar-pop>
      </div>
    </div>
    <div
      v-show="showNav"
      class="app-nav"
    >
      <head-nav></head-nav>
    </div>
    <div
      class="app-content"
      v-if="isRefreshPage"
    >
      <keep-alive :include="[unKeepAliveName]">
        <router-view class="app-view" />
      </keep-alive>
      <!-- <router-view v-if="!$route.meta.keepAlive"
                   class="app-view" /> -->
    </div>
    <div
      class="mask"
      v-if="showMask"
      @click="hideMenu"
    ></div>
    <date-select-panel></date-select-panel>
    <popup-info
      :isShow.sync="isShowInfo"
      :contentObj="popUpObj"
    ></popup-info>
    <u-watermark :text="waterTxt"></u-watermark>
  </div>
</template>

<script>
import HeadNav from './components/common/HeadNav'
import DateSelectPanel from './components/common/DateSelectPanel'
import PopupInfo from './components/common/PopupInfo'
import apiService from './assets/js/api'
import UWatermark from './components/common/UWatermark'
import MorebarPop from './components/common/MorebarPop'
import * as dd from 'dingtalk-jsapi'
import { Dialog } from 'vant'
import { isIPhone, isAndroid } from './assets/js/core/weapon.js'
export default {
  name: 'App',
  data () {
    return {
      iosHeight: '',
      isRefreshPage: true,
      // selectIcon: './Icon/xuan@2x.png',
      isShowMoreBar: false,
      backIcon: './Icon/back.png',
      morebarImg: './Icon/morebar.png',
      waterTxt: '',
      navList: [
        { name: '红黑榜', url: '/rank', show: false },
        { name: '今日资讯', url: '/news', show: false },
        { name: '营销', url: '/', show: false },
        { name: '营销-海外', url: '/marketAbroad', show: false },
        { name: '财务', url: '/finance', show: false },
        { name: '生产', url: '/production', show: false }
      ]
      // fixunKeepAliveIndex: ['market', 'finance', 'production'],
      // fixunKeepAliveMarket: ['KcSecondInDetail', 'KcSecondOutDetail', 'KcThirdInDetail', 'KljgThirdInDetail', 'SaleSecondOutDetail', 'SaleThirdInDetail', 'SaleThirdOutDetail', 'SzlSecondDetail'],
      // fixunKeepAliveFinance: ['GxfDetail', 'JlrDetail', 'JyhdDetail', 'PplrDetail'],
      // fixunKeepAliveProduction: ['BaseDetail']
    }
  },
  computed: {
    isNewsIndex () {
      return this.$route.path === '/news'
      //  this.$store.state.isNewsIndex;
    },
    isNewsPage () {
      return this.$store.state.isNewsPage
    },
    unKeepAliveName () {
      return this.$store.state.unKeepAliveName
    },
    popUpObj () {
      return this.$store.state.popUpObj
    },
    isShowInfo () {
      return this.$store.state.popupShow
    },
    pageTitle () {
      return this.$store.state.pageTitle
    },
    showMask () {
      return this.$store.state.showMask
    },
    showNav () {
      return this.$store.state.showNav
    },
    showBackBtn () {
      return this.$store.state.showBackBtn
    }
  },
  methods: {
    onBarMask () {
      this.isShowMoreBar = false
      // console.log('点击了遮罩', this.isShowMoreBar)
    },
    showEdition () {
      Dialog.alert({
        title: '提示',
        message: '当前版本为0312二'
      }).then(() => {
      })
    },
    refresh () {
      this.isShowMoreBar = false
      this.isRefreshPage = false
      this.$nextTick(() => {
        this.isRefreshPage = true
      })
    },
    showMoreBar () {
      console.log('这里也触发吗')
      this.isShowMoreBar = !this.isShowMoreBar
    },
    hideMenu () {
      this.$store.commit('updateShowLeft', false)
      this.$store.commit('updateShowMask', false)
    },
    showDatePanel () {
      this.isShowMoreBar = false
      this.$store.commit('updateShowLeft', true)
      this.$store.commit('updateShowMask', true)
    },
    selectedPage (index, item) {
      this.activeIndex = index
      this.$store.commit('updateUnKeepAliveName', null)
      this.$store.commit('updateNavIndex', index)
      this.$store.commit('updateInitDateStr', true)
      this.$store.commit('updateProductTab', 0)
      this.$router.replace({ path: item.url, query: { isRouterReplace: true } })
    },

    backPrePage () {
      // if (
      //   this.$route.path !== '/finance' &&
      //   this.$route.path !== '/production' &&
      //   this.$route.path !== '/'
      // ) {
      //   this.$router.go(-1)
      // } else {
      //   // 退出程序，到最外层
      // }
      // this.$router.go(-1)

      if (this.$route.path === '/rank' || this.$route.path === '/news' || this.$route.path === '/' || this.$route.path === '/marketAbroad' || this.$route.path === '/finance' || this.$route.path === '/production'|| this.$route.path === '/scoreList') {
        dd.biz.navigation.close()// 如果是五个首页则关闭页面
      } else {
        this.$router.go(-1)
      }
    },
    async getUserInfo () {
      const { __statusCode, data } = await apiService.getDataFromInterface(
        apiService.getUserInfo
      )
      if (Object.is(__statusCode, '1')) {
        // this.drawWaterMark(data.loginName + '     ' + data.loginId)
        this.waterTxt = data.loginName + '     ' + data.loginId
      }
    }
  },
  components: {
    HeadNav,
    DateSelectPanel,
    PopupInfo,
    UWatermark,
    MorebarPop
  },
  mounted () {
    this.getUserInfo()
    if (isIPhone()) {
      const viewHeight = document.body.clientHeight - 20
      this.iosHeight = viewHeight + 'px'
      document.body.style.height = viewHeight + 'px'
    }
  }
}
</script>

<style lang="scss">
#app {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
  box-sizing: border-box;
  height: 100vh;
  width: 100%;
  background-image: url('../public/bg.jpg');
  background-size: 100% 100%;
  // background: linear-gradient(#1D3565, #2E315C);
  display: flex;
  flex-direction: column;
  .app-title {
    width: 100%;
    height: px2rem(88);
    flex-shrink: 0;
    // background-color: #05215e;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    position: relative;
    z-index: 999;
    .title {
      position: absolute;
      z-index: 50;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: px2rem(36);
      color: #ffffff;
      text-align: center;
      line-height: px2rem(88);
    }
    .back-btn {
      margin-left: px2rem(30);
      width: px2rem(100);
      font-size: px2rem(28);
      color: #ffffff;
      z-index: 99;
      .back-img {
        width: px2rem(40);
      }
    }
    .back-btn-blank {
      margin-left: px2rem(30);
      width: px2rem(100);
      font-size: px2rem(28);
      color: #ffffff;
      z-index: 99;
    }
    .option {
      width: px2rem(200);
      font-size: px2rem(28);
      color: #ffffff;
      position: absolute;
      right: 0;
      z-index: 55;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .option__bar {
        margin-left: px2rem(10);
        margin-right: px2rem(30);
        width: px2rem(56);
      }
    }
  }
  .app-view {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }
  .app-nav {
    width: 100%;
    height: px2rem(88);
  }
  .app-content {
    // -webkit-overflow-scrolling: touch;
    flex-grow: 1;
    z-index: 10;
    // height: 0;
    overflow: scroll;
    position: relative;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 88;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
}
</style>
